import { render, staticRenderFns } from "./indexCategoryItems.vue?vue&type=template&id=3b7f88a1&scoped=true&"
import script from "./indexCategoryItems.vue?vue&type=script&lang=js&"
export * from "./indexCategoryItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7f88a1",
  null
  
)

export default component.exports